// Runtime configuration helper
// This allows us to use environment variables that are injected at runtime
// instead of being baked in at build time

declare global {
  interface Window {
    _env_?: {
      [key: string]: string | undefined;
    };
  }
}

export function getRuntimeConfig(key: string): string | undefined {
  // First check runtime config (injected by Docker at startup)
  if (typeof window !== 'undefined' && window._env_ && window._env_[key]) {
    return window._env_[key];
  }
  
  // Fall back to process.env (for local development)
  return process.env[key];
}

export function getRuntimeConfigOrDefault(key: string, defaultValue: string): string {
  return getRuntimeConfig(key) || defaultValue;
}